import { createI18n } from "vue-i18n";
import { useLocalStorageStore } from "@/stores/localStorage";
import { LANGUAGE } from "@/stores/models/localStorage";
import { nextTick } from "vue";

const setupI18n = () => {
    const options = {
        legacy: false,
        globalInjection: true,
        locale: "de",
        fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    };
    const i18n = createI18n(options);
    setI18nLanguage(i18n);

    return i18n;
};

export const i18nInstance = setupI18n();

export function setI18nLanguage(i18n) {
    nextTick(async () => {
        // if url contains 'showTranslationKeys', do not set language
        if (window.location.search.indexOf("showTranslationKeys") > 0) return;

        // try to identify the current language
        const localStorageStore = useLocalStorageStore();
        let storedLanguage = localStorageStore.getLanguage;

        if (!storedLanguage) {
            const browserLanguage = window.navigator.language.split("-")[0].toUpperCase();
            const browserLanguageKey = localStorageStore.getLanguageKeyByValue(browserLanguage);
            const languageKey = browserLanguageKey || "DE";

            localStorageStore.setLanguage(languageKey);
            // reassign storedLanguage (this time is is set for sure)
            storedLanguage = localStorageStore.getLanguage!;
        }

        // set i18n language
        i18n.global.locale.value = storedLanguage;

        /**
         * NOTE: If you need to specify the language setting for headers, do it here.
         * For example:
         * axios.defaults.headers.common['Accept-Language'] = locale
         */

        document.querySelector("html")!.setAttribute("lang", storedLanguage);

        // load locale messages with dynamic import
        const messages = await import(
            /* webpackChunkName: "locale-[request]" */
            `./locales/${storedLanguage}.json`
        );

        // set locale and locale message
        i18n.global.setLocaleMessage(storedLanguage, messages.default);
    });
}

export function setLanguage(locale: keyof typeof LANGUAGE) {
    useLocalStorageStore().setLanguage(locale);

    setI18nLanguage(i18nInstance);
    /* TODO: should not be needed any more */
    location.reload();
}
